import { diaDaData } from '@/produtividade/dia';
import { agendamentosDoResumo, leadsComComparecimentoPossivel } from '@/produtividade/indicadores';
import {
  buscarAgendamentosDoDia, buscarAgendamentosDosLeads, buscarInteracoesDoDia,
} from '@/services/produtividadeService';

const SO_SERVIDOR = { soServidor: true };

/**
 * ★★ 1.3 — AS CONSULTAS DO RESUMO DE HOJE, só do dia. Servem a abertura dos Indicadores e, desde a
 * A2, o clique em copiar. ★ Sempre do SERVIDOR (`soServidor`): sem ele, erro — nunca a cópia
 * local calada.
 *
 * ★ Mora fora do `produtividadeService` de propósito: chama as buscas dele pelo módulo, então os
 * testes que simulam o serviço função por função continuam simulando estas consultas.
 *
 * ★ Os agendamentos dos leads que podem ter comparecimento hoje vêm à parte
 * (`buscarAgendamentosDosLeads`, poucos): é o que mantém o crédito igual ao da grade. Os
 * leads com carimbo de hoje já são conhecidos, então essa busca vai JUNTO com as do dia; só
 * um `compareceu` do dia em lead SEM carimbo pede uma segunda ida, que sai assim que os
 * agendamentos do dia chegam (medido a 4×: em série, ela custava 2,5 s).
 *
 * @param lerLeads função que devolve os leads da memória NO MOMENTO (a 2ª ida relê)
 */
export function buscarDadosDoResumo(clinicaId, lerLeads, referencia = new Date()) {
  const dia = diaDaData(referencia);
  const comCarimbo = leadsComComparecimentoPossivel({ dia, leads: lerLeads() });
  const jaBuscados = new Set(comCarimbo);
  const agendamentosDoDia = buscarAgendamentosDoDia(clinicaId, referencia, SO_SERVIDOR);
  return Promise.all([
    buscarInteracoesDoDia(clinicaId, referencia, SO_SERVIDOR),
    agendamentosDoDia,
    comCarimbo.length ? buscarAgendamentosDosLeads(clinicaId, comCarimbo, SO_SERVIDOR) : [],
    // ★ a 2ª ida sai assim que os agendamentos do dia chegam, sem esperar as interações
    agendamentosDoDia.then((ags) => {
      const faltam = leadsComComparecimentoPossivel({ dia, leads: lerLeads(), agendamentosDoDia: ags })
        .filter((id) => !jaBuscados.has(id));
      return faltam.length ? buscarAgendamentosDosLeads(clinicaId, faltam, SO_SERVIDOR) : [];
    }),
  ]).then(([is, ags, dosCarimbados, dosOutros]) => ({
    dia,
    interacoes: is,
    agendamentos: agendamentosDoResumo({
      dia, agendamentosDoDia: ags, agendamentosDosLeads: [...dosCarimbados, ...dosOutros],
    }),
  }));
}
